const globalInfo = () => {
    return {
        stableVersion: "2.0.0"
    }
}

export default globalInfo